import ScheduleActivityEntityBlock from './ScheduleActivityEntityBlock';

export default ScheduleActivityEntityBlock;
